module.exports = __webpack_public_path__ + "img/icon3.05a67c47.png";